function accordion(){
    const SELECTOR = ".js_accordion";
    const accordions = window.document.querySelectorAll(SELECTOR);
    if(accordions.length < 1) return;

    accordions.forEach(accordion => {
        if(accordion.getAttribute("data-accordion-is-open") !== null) toggleAccordion.bind(accordion)();
        
        accordion.addEventListener("click",toggleAccordion)
        });

    function toggleAccordion(){
        const bodyId = this.getAttribute("data-accordion-body");

        const accordionBody = window.document.getElementById(bodyId) || this.nextElementSibling
        if(!accordionBody) return;

        const onlyMobile = this.getAttribute("data-accordion-mobile-only") === "true";

        if(onlyMobile && window.innerWidth > 750) return;

        if(accordionBody.style.maxHeight) {
            this.classList.remove("active");
            accordionBody.style.maxHeight = null;
            }
        else{
            const active = window.document.querySelectorAll(SELECTOR + ".active")
            
            for (let j = 0; j < active.length; j++){
                active[j].classList.remove("active");
                const activeBody = active[j].nextElementSibling;
                
                if(!activeBody) return;
                // @ts-ignore
                activeBody.style.maxHeight = null;
            }
            this.classList.add("active");
            accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
        }
    }
}
window.addEventListener('load',accordion);